<template src="./index.html"></template>
<style src="./style.scss" lang="scss" scoped></style>
<script>
import { mapGetters } from 'vuex';
import Navbar from '@/components/Navbar';
import {
  M_ONBOARDING_STEP
} from '@/graphql';
export default {
  name: 'Numbers',
  components: { Navbar },
  computed: {
    ...mapGetters({
      user: 'auth/getUser'
    }),
    firstName() {
      return this.user.firstName;
    }
  },
  data() {
    return {
      option: null
    }
  },
  methods: {
    async chooseOption(option) {
      this.option = option;
      console.log(option);
      if (option === 'advanced') {
        console.log('setting onboarding_step');
        await this.$apollo.mutate({
          mutation: M_ONBOARDING_STEP,
          variables: {
            user_id: this.user.id,
            onboarding_step: 1
          }
        });
      }
    }
  }
};
</script>
